import React from 'react';

import classNames from 'classnames';

export interface IModalContentProps {
    children: React.ReactNode;
    className?: string;
}

export const ModalContent = (props: IModalContentProps): JSX.Element => {
    const className: string = classNames(
        'modal__content',
        props.className,
    );

    return <div className={className}>{props.children}</div>;
};
